import { AbsolutePaths } from "constants/routes";
import { PageNames } from "types-for/routes";

export const STATIC_ROUTES = [AbsolutePaths[PageNames.Settings]()];
